import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import './SessionsList.scss';
import images from '../../assets/images';
import { GetAllSavedSessionsType, LiveSessionListType, SingleSessionType } from '../../pages/LiveClass/LiveClass';
import { calculateDays, calculateDuration, convertToMinutes, formatPart, formatSavedDate, formatTime, getFormattedDateInfo, getIsJoinedLocalValue, getScreenDimensions, hasUserAlreadyJoined } from '../../utils/helper';
import { CircularProgress, FormControlLabel, FormLabel, Menu, MenuItem, Radio, RadioGroup, Tooltip } from '@mui/material';
import { useLazyQuery, useMutation } from '@apollo/client';
import { DELETE_SCHEDULED_SESSION, GET_SESSTION_BY_ID, UPDATE_HOST_FROM_CLASSROOM, UPDATE_KATON_MEET_CHAT_STATUS } from '../../pages/LiveClass/api/LiveClassQuery';
import { UPDATE_LIVECLASS_HOST_ID } from '../../Chime/helpers/Api/ChimeApi';
import { useAppSelector } from '../../redux/app/hooks';
import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import ToasterWithMessage from '../toaster';
import { useLocation, useNavigate } from 'react-router-dom';
import { ALERT_MESSAGE_ALREADY_IN_MEETING, ALERT_MESSAGE_TWO_USERS, CHIME, FETCH_POLICY_NO_CACHE, JITSI, PATH_ADDRESSES, STUDENT_ROLE, SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR, SUBJECT_NOT_FOUND_ERROR, TEACHER_ROLE, KATON_MEET_MESSAGES } from '../../utils/constants';
import { useGlobalState } from '../../MeetContext/MeetContext';
import WarningPopup from '../WarningPopup/WarningPopup';
import { getChimeParticipants } from '../../Chime/helpers/get-participants';
import { useChimeMeeting } from '../../Chime/ChimeMeetingContext';
import { setCurrentSessionId, setCurrentUserId, setIsStartingMeeting, setMeetComponentName } from '../../redux/slices/dashboardSlice';
import { useDispatch } from 'react-redux';
import { useKatonMeet } from '../KatonMeet/KatonMeetContext';
import { buildRecordingUrl, getKatonMeetMeetingId, isKatonMeetLiveClass, KATON_MEET_URL } from '../KatonMeet/katonMeetConfig';

interface PropsType{
    setShowCreateScheduling: (val: boolean) => void;
    setClickedVideoData: any
    upcomingSessionList: LiveSessionListType[];
    singleSessionDetail: SingleSessionType | undefined;
    setSingleSessionDetail: (val: SingleSessionType|undefined) => void;
    savedSessionsList: GetAllSavedSessionsType | undefined;
    setClickedVideoUrl: (val: string) => void;
    setClickedSessionDetails?: any;
    clickedSessionDetails?: SingleSessionType | undefined;
    setIsDeleted: (val: boolean) => void;
    fetchUpcomingSessions: any;
    isClickedSessionDetail: boolean;
    setIsClickedSessionDetail: (val: boolean) => void;
    setEditClicked: (val:boolean) => void;
    setIsTeacherButtonClicked : (value: boolean) => void;
    isTeacherButtonClicked : boolean;
    SetIsMoreClick : (val:boolean) => void;
    sessionEnded : boolean;
    handleStartMeeting: any;
    handleJoinMeeting: any;
    fetchSessionDetails : () => void
    setIsStudentButtonClicked : (value: boolean) => void;
    isStudentButtonClicked : boolean;
    isMoreClick : boolean;
    setSessionEnded : (val : boolean) => void;
    hideCreateButton?: boolean;
}

export interface SavedSessionType {
  rsId: string;
  savedSessionUrl: string;
  recordSessionType: string;
  createdAt: string;
  sjId: string;
  sessionId: string;
  topic: string;
  isKatonMeet?: boolean | null;
  videosPlaybacktimesByRsId: {
    nodes: [{
      playbackTime: string;
    }]
  }
}

const SessionsList:FC<PropsType> = ({
    setIsClickedSessionDetail, 
    setEditClicked, 
    setClickedVideoData, 
    isClickedSessionDetail, 
    fetchUpcomingSessions, 
    setShowCreateScheduling, 
    setIsDeleted,  
    clickedSessionDetails, 
    setClickedVideoUrl, 
    savedSessionsList, 
    setClickedSessionDetails,  
    upcomingSessionList, 
    setSingleSessionDetail, 
    singleSessionDetail,
    setIsTeacherButtonClicked ,
    isTeacherButtonClicked,
    SetIsMoreClick,
    sessionEnded,
    handleStartMeeting,
    fetchSessionDetails ,
    setIsStudentButtonClicked ,
    isStudentButtonClicked,
    handleJoinMeeting,
    isMoreClick,
    setSessionEnded,
    hideCreateButton = false
}) => {
  const {MoreIcon, WhiteMoreIcon, calendarSymbol,clockSymbol, sandWatch, videoPlayIcon, DeleteClass, ResetCode, DeleteGif, LiveSessionGif, ScheduleMeeting} = images;
  const [isClickedStartButton, setIsClickedStartButton] = useState<boolean>(false);
  const [daysleftValue, setDaysleftValue] = useState('');
  const [startTime, setStartTime] = useState('');
  const [duration, setDuration] = useState('');
  const {success,error} = ToasterWithMessage();
  const selectedClassRoomId = useAppSelector((state) => state.auth.selectedClassRoomId);
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const [isOverflow, setIsOverflow] = useState(false);
  const [isDescOverflow,setIsDescOverflow] = useState<boolean[]>([]);
  const descriptionRef = useRef<HTMLDivElement | null>(null);
  const videoDescriptionRef = useRef<(HTMLSpanElement | null)[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [menuSessionId, setMenuSessionId] = useState<string>();
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const navigate = useNavigate();
  const role = useAppSelector((state) => state.auth.role);
  const meetService = useAppSelector((state) => state.auth.meetService)
  const schoolType = useAppSelector((state) => state.auth.schoolType);
  const { openMeeting: openKatonMeet, session: openKatonMeetSession, mode: katonMeetMode } = useKatonMeet();
  // A full-screen Katon Meet meeting covers this page, so the session poll pauses until the user is back
  // on the page (meeting minimized to PiP or closed). Kept in a ref for the interval callback.
  const isMeetingCoveringPageRef = useRef(false);
  isMeetingCoveringPageRef.current = Boolean(openKatonMeetSession) && katonMeetMode === 'full';
  const [openWarningPopup, setOpenWarningPopup] = useState<boolean>(false);
  const {localStream, setIsMeetingEndByHost} = useGlobalState();
  const { isMobileScreen } = getScreenDimensions();
  const [warningMessage, setWarningMessage] = useState<string>('');
  const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent.toLowerCase());
  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const [alreadyTwoUsersSameId, setAlreadyTwoUsersSameId] = useState<boolean>(false)
  const currentUserId = profile?.getCurrentUser?.nodes?.[0]?.uId;
  const dispatch = useDispatch();
  const {state} = useLocation();
  const isJoined = localStorage.getItem("isJoined") || '';
  const [popupMessage, setPopupMessage] = useState<string | null>(); 
  const [startButtonClick, setStartButtonClick] = useState<boolean>(false);
  const { showChat, setShowChat } = useChimeMeeting();
  const { isStartingMeeting } = useAppSelector((state) => state?.dashboard);

  const [deleteSession] = useMutation(DELETE_SCHEDULED_SESSION, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
      setShowCreateScheduling(false);
      setIsDeleted(true);
      success("Deleted successfully");
    },
    onError: (err) => {
      error(err?.message);
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        setTimeout(() => {
          if(role === STUDENT_ROLE){
             navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
          }else{
             navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
          }
        }, 2000);
      }
    }
  });
  
  const textRef = useRef<HTMLDivElement | null>(null);
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const handleMouseEnter = () => {
    const div = textRef.current;
  
    if (div) {
      const isOverflowing = div.scrollHeight > div.clientHeight;
      setShowTooltip(isOverflowing);
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };



  const getPreviewStream = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true});
      console.log("[Log] stream", stream, stream?.getTracks());
      stream.getTracks().forEach((track) => track.stop());
      return stream;
    } catch (err: any) {
      console.log("[Log] getPreviewStream Error", err);
      let errorMessage = "Unable to access your camera or microphone. Please check your device settings and try again.";
      if (err?.name === "NotAllowedError" || err?.name === "SecurityError") {
        errorMessage = "Permission denied. Please allow camera and microphone access.";
      } else if (err?.name === "NotFoundError" || err?.name === "DevicesNotFoundError") {
        errorMessage = "No camera or microphone found. Please check your device.";
      } else if (err?.name === "NotReadableError" || err?.name === "HardwareAccessError") {
        errorMessage = "Another app is using your camera or microphone. Close the other app and try again.";
      } else if (err?.name === "OverconstrainedError") {
        errorMessage = "Your camera does not support the requested video resolution.";
      }
      setWarningMessage(errorMessage);
      if (role === TEACHER_ROLE) {
        setIsTeacherButtonClicked(false);
      } else if (role === STUDENT_ROLE) {
        setIsStudentButtonClicked(false);
      }
      setOpenWarningPopup(true);
    }
  };

  // Live classes run on Katon Meet when the env chooses it for this school type
  // (REACT_APP_VIRTUAL_MEET_SERVICE for virtual schools, REACT_APP_MEET_SERVICE otherwise).
  const isKatonMeet = isKatonMeetLiveClass(schoolType);
  // Katon Meet: the session's time has arrived and it hasn't ended
  const isKatonMeetReady = Boolean(singleSessionDetail?.isActive) && !sessionEnded;
  const isKatonMeetStarted = isKatonMeetReady && Boolean(singleSessionDetail?.isSessionStart);
  const showCreateButton = !singleSessionDetail && role === TEACHER_ROLE && !hideCreateButton;

  // The session's Katon Meet meeting id (mId in getSession's katonMeetResponse)
  const katonMeetMeetingId = getKatonMeetMeetingId(singleSessionDetail?.katonMeetResponse);

  const canOpenKatonMeet = () => {
    if (!KATON_MEET_URL) {
      error(KATON_MEET_MESSAGES.notAvailable);
      return false;
    }
    if (!katonMeetMeetingId) {
      error(KATON_MEET_MESSAGES.notReady);
      return false;
    }
    return true;
  };

  const [updateHostFromClassroom] = useMutation(UPDATE_HOST_FROM_CLASSROOM);
  const [updateLiveClassHostId] = useMutation(UPDATE_LIVECLASS_HOST_ID);
  const [updateKatonMeetChatStatus] = useMutation(UPDATE_KATON_MEET_CHAT_STATUS);
  const [isKatonMeetStarting, setIsKatonMeetStarting] = useState<boolean>(false);

  const openKatonMeetMeeting = () => {
    if (!canOpenKatonMeet()) return;
    const opened = openKatonMeet({
      sessionId: singleSessionDetail?.sessionId || 'katon-meet',
      meetingId: katonMeetMeetingId,
      title: singleSessionDetail?.lessonTopic || KATON_MEET_MESSAGES.defaultTitle,
    });
    if (!opened) {
      error(KATON_MEET_MESSAGES.alreadyOpen);
    }
  };

  // Teacher Start: any teacher of the class may start, whoever created the session.
  // 1. If they aren't the session's host yet, make them host (Classroom + Katon Meet)
  // 2. Save host and chat setting in parallel, like the Chime start does
  // 3. Open the meeting lobby; the backend marks the session started once the meeting starts in Katon Meet
  const handleStartKatonMeet = async () => {
    const sessionId = singleSessionDetail?.sessionId;
    if (isKatonMeetStarting || !sessionId || !currentUserId || !canOpenKatonMeet()) return;
    setIsKatonMeetStarting(true);
    try {
      if (singleSessionDetail?.hostId !== currentUserId) {
        await updateHostFromClassroom({ variables: { mId: katonMeetMeetingId } });
      }
      await Promise.all([
        updateLiveClassHostId({
          variables: {
            input: {
              pCId: selectedClassRoomId,
              pSubjectId: selectedSubjectId,
              pSessionId: sessionId,
              pHostId: currentUserId,
              pUpdateOriginal: true,
            },
          },
        }),
        updateKatonMeetChatStatus({
          variables: {
            cId: selectedClassRoomId,
            sjId: selectedSubjectId,
            sessionId,
            // Same rule as the Chime start: the teacher's choice before the first start, the saved value after
            showChat: singleSessionDetail?.isSessionStart ? Boolean(singleSessionDetail?.showChat) : showChat,
          },
        }),
      ]);
    } catch (err: any) {
      error(err?.message || KATON_MEET_MESSAGES.startFailed);
      return;
    } finally {
      setIsKatonMeetStarting(false);
    }
    openKatonMeetMeeting();
  };

  // Katon Meet's Start/Join button, styled like the Chime one; opens the meeting lobby.
  // Teacher: "Start" (runs the start steps above) until the meeting has started, then "Join".
  // Student: "Join" only once a teacher has started the meeting.
  const renderKatonMeetSessionButton = () => {
    const isStudent = role === STUDENT_ROLE;
    const isEnabled = isStudent ? isKatonMeetStarted : isKatonMeetReady;
    const readyClass = isStudent ? 'sessionJoinButton' : 'sessionStartButton';
    const notReadyClass = isStudent ? 'notReadyStudentButtonStyle' : 'notReadyButtonStyle';
    let label: ReactNode = isKatonMeetStarted ? 'Join' : 'Start';
    if (sessionEnded) {
      label = 'Session Ended';
    } else if (!isEnabled) {
      label = 'Not Ready';
    } else if (isKatonMeetStarting) {
      label = <CircularProgress size={15} color="inherit" />;
    }
    return (
      <>
        <button
          type="button"
          className={isEnabled ? readyClass : notReadyClass}
          // Joining an already started meeting needs no API call; starting goes through the start steps
          onClick={isKatonMeetStarted ? () => openKatonMeetMeeting() : handleStartKatonMeet}
          disabled={!isEnabled || isKatonMeetStarting}
        >
          {label}
        </button>
        {isStudent && isKatonMeetReady && !isKatonMeetStarted && (
          <span className='sessionNotYetStarted'>
            Host has not yet started the meeting
          </span>
        )}
      </>
    );
  };

  const handleClickStartButton = async () => {
    setIsTeacherButtonClicked(true);
    dispatch(setIsStartingMeeting({ isStartingMeeting: true }));
    dispatch(setCurrentSessionId({ currentSessionId: singleSessionDetail?.sessionId || '' }));
    if (meetService === JITSI) {
      setIsClickedStartButton(true);
      handleStartMeeting();
    } else {
      // const stream = await getPreviewStream();
      // if (stream) {
        dispatch(setCurrentUserId({ currentUserId: currentUserId || '' }));
        dispatch(setMeetComponentName({ meetComponent: 'liveclass' }));
        setIsClickedStartButton(true);
        localStorage.setItem("functionality", "start");
        if(window?.electron && window?.electron?.isElectron()) {
            window?.electron?.openMeetingWindow(`teacher-classroom/liveclass/premeeting?meetId=${singleSessionDetail?.sessionId}`, state);
        } else  {
            window.open(`/teacher-classroom/liveclass/premeeting?meetId=${singleSessionDetail?.sessionId}`, "_blank");
        }
        // handleStartMeeting(stream);
      // }
    }
    setOpenConfirmationPopup(false);
    setStartButtonClick(false);
  }

  const handleClickJoinButton = async () => {
    dispatch(setIsStartingMeeting({ isStartingMeeting: true }));
    dispatch(setCurrentSessionId({ currentSessionId: singleSessionDetail?.sessionId || '' }));
    if (role === TEACHER_ROLE) {
      setIsTeacherButtonClicked(true);
    } else if (role === STUDENT_ROLE) {
      setIsStudentButtonClicked(true);
    }
    if (meetService === JITSI) {
      handleJoinMeeting();
    } else {
        dispatch(setCurrentUserId({ currentUserId: currentUserId || '' }));
        dispatch(setMeetComponentName({ meetComponent: 'liveclass' }));
        handleJoinMeeting();
    }
  }

  const [getSingleSessionDetail] = useLazyQuery(GET_SESSTION_BY_ID, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: async (data) => {
      const response = data?.getSession || {};
      const meetId = response?.sessionCode;

      // Katon Meet sessions have no Chime meeting (their sessionCode is the Katon Meet id), so skip the Chime lookup
      if (meetId && meetService !== JITSI && !response?.isKatonMeet) {
        getChimeParticipants(meetId)
          .then((participantsResponse) => {
            const chimeParticipants = participantsResponse?.Attendees?.filter((participant: any) => {
              if (!participant?.ExternalUserId?.includes("aws:MediaPipeline")) {
                return !participant?.ExternalUserId?.includes("aws:MediaPipeline");
              }
            })
            console.log("participantsResponse", participantsResponse, chimeParticipants);
            response.participantscount = chimeParticipants ? chimeParticipants.length : 0;
          })
          .catch(() => {
            response.participantscount = 0;
          })
          .finally(() => {
            console.log("[Log] Participants count:", response.participantscount);
            if (isMoreClick === false) {
              setSingleSessionDetail(response);
            } else {
              setClickedSessionDetails({ ...response, type: "liveclass" });
            }
          });
      } else {
        if (isMoreClick === false) {
          setSingleSessionDetail(response);
        } else {
          setClickedSessionDetails({ ...response, type: "liveclass" });
        }
      }
      setSessionEnded(false);
    },
    onError: (err) => {
      if (err?.message === SUBJECT_NOT_FOUND__FOR_TEACHER_ERROR || err?.message === SUBJECT_NOT_FOUND_ERROR) {
        error(err?.message);
        setTimeout(() => {
          if(role === STUDENT_ROLE){
            navigate(PATH_ADDRESSES?.STUDENT_CLASSROOM_PATH);
         }else{
            navigate(PATH_ADDRESSES?.TEACHER_CLASSROOM_PATH);
         }
        }, 2000);
      } else if(err?.message === "Session has ended"){
         setSessionEnded(true);
         setTimeout(() => {
          setSingleSessionDetail(undefined);
          fetchUpcomingSessions();
        }, 5000); 
      }else {
        error(err?.message)
      }
    }
  });


  const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    const sessionIdToDelete = menuSessionId || clickedSessionDetails?.sessionId;
    if (!sessionIdToDelete) {
      error("Unable to delete this session. Please try again.");
      return;
    }
    deleteSession({
        variables: {
          cId: selectedClassRoomId,
          sjId: selectedSubjectId,
          sId: sessionIdToDelete,
          ...(meetService === JITSI ? { pMeetingType: "JITSI" } : {}),
        }
      })
  }

  const onNoButtonClick = () => {
      setOpenConfirmationPopup(false);
  }


  //set the particular data when click card
  const onClickSingleSession = (cardItem:LiveSessionListType) => {
    setIsClickedSessionDetail(true);
    // localStorage.setItem("SessionId",cardItem?.sessionId);
    SetIsMoreClick(false);
    if(openMenu === false){
      getSingleSessionDetail({
        variables:{
          input:{
            cId:selectedClassRoomId,
            sjId:selectedSubjectId,
            sId:cardItem?.sessionId
          }
        }
      })
    }
  };



  const onClickMoreIcon = (event: React.MouseEvent<HTMLElement>,item: LiveSessionListType) => {
    event.stopPropagation(); // Stop propagation to prevent triggering parent click
    setAnchorEl(event.currentTarget);
    setMenuSessionId(item?.sessionId);
    setClickedSessionDetails?.(undefined);
    SetIsMoreClick(true);
    getSingleSessionDetail({
      variables:{
        input:{
          cId:selectedClassRoomId,
          sjId:selectedSubjectId,
          sId:item?.sessionId
        }
      }
    })
    // setClickedSessionDetails(item)
    setOpenMenu(true);
  }

  const handleCloseMenu = () => {
    setOpenMenu(false);
  }

  // Edit and Delete stay disabled until the latest details of the session whose menu is open have loaded
  const isMenuSessionLoaded = Boolean(menuSessionId) && clickedSessionDetails?.sessionId === menuSessionId;

  const onClickEditOption = () => {
        setEditClicked(true);
        handleCloseMenu();
        setShowCreateScheduling(true);
  }

  const onClickDeleteScheduleOption = () => {
        handleCloseMenu();
        setOpenConfirmationPopup(true);
  }

//To check the container is overflow
const checkOverflow = () => {
  if (descriptionRef.current) {
    setIsOverflow(descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight);
  }
};

const checkOverflowVideoDescription = (index:number) => {
  if(videoDescriptionRef.current[index]){
    const overflow = (videoDescriptionRef.current[index]!.scrollHeight - 1) > videoDescriptionRef.current[index]!.clientHeight;
    setIsDescOverflow(prev => {
                const newOverflow = [...prev];
                newOverflow[index] = overflow;
                return newOverflow;
    });
  }
}

const handleResize = () => {
  if(savedSessionsList && savedSessionsList?.totalCount > 0){
    savedSessionsList?.nodes.forEach((_, index) => {
      checkOverflowVideoDescription(index);
    });
  }
};

 //To check overflow in resize 
 useEffect(() => {
  if (savedSessionsList?.nodes) {
    savedSessionsList?.nodes.forEach((_, index) => {
          checkOverflowVideoDescription(index); // Check overflow for each classroom name
      });
  }
}, [savedSessionsList]);

const handleClickVideo = (videoItem: SavedSessionType) => {
  setClickedVideoUrl(buildRecordingUrl(videoItem?.savedSessionUrl, videoItem?.isKatonMeet));
  setClickedVideoData(videoItem);
}

const checkJoinDetails =() => {
 const alreadyJoined = hasUserAlreadyJoined(singleSessionDetail?.participantIds || [], currentUserId);
        console.log(alreadyJoined, "alreadyJoined")
        if(alreadyJoined) {
        setAlreadyTwoUsersSameId(alreadyJoined)
        }
      else{
          setAlreadyTwoUsersSameId(false)
      }
}
 
  useEffect(() => {
    if(singleSessionDetail){
      const daysLeft = calculateDays(singleSessionDetail?.startdate);
      const startTimeFormatted = formatTime(singleSessionDetail?.startdate);
      const durationFormatted = calculateDuration(singleSessionDetail?.startdate, singleSessionDetail?.enddate);

      setDaysleftValue(daysLeft);
      setStartTime(startTimeFormatted);
      setDuration(durationFormatted);
      checkOverflow();
      const interval = setInterval(() => {
        if (isMeetingCoveringPageRef.current) return;
        fetchSessionDetails();
        checkJoinDetails()
      }, 10000); // 60000 ms = 1 minute

      return () => clearInterval(interval);
    }
  },[singleSessionDetail])

  useEffect(() => {
    if (singleSessionDetail?.showChat !== undefined &&
        singleSessionDetail?.showChat !== null) {
          console.log("showChat set:",singleSessionDetail.showChat);
      setShowChat(singleSessionDetail.showChat);
    }
  }, [singleSessionDetail?.showChat]);

  

  //To check overflow in resize 
  useEffect(() => {
    setIsMeetingEndByHost(false);
    setShowChat(Boolean(process.env.REACT_APP_SHOW_CHAT_DEFAULT));
    //To set stop camera and microphone when initial render.
        if(localStream?.getVideoTracks()[0]){
            localStream.getVideoTracks()[0].enabled = false;
        }
        localStream?.getVideoTracks()[0]?.stop();
        if(localStream?.getAudioTracks()[0]){
            localStream.getAudioTracks()[0].enabled = false;
        }
        localStream?.getAudioTracks()[0]?.stop();
        handleResize(); 
        setIsTeacherButtonClicked(false);
        setIsStudentButtonClicked(false);

        window.addEventListener('resize', checkOverflow);
        window.addEventListener('resize',handleResize);

        return () => {
            window.removeEventListener('resize', checkOverflow);
            window.addEventListener('resize',handleResize);
        };
  }, []);
 


const closeWarnPopup = () => {
  setOpenWarningPopup(false);
  setWarningMessage("");
}

const handleLoadedMetadata = (event: React.SyntheticEvent<HTMLVideoElement>) => {
  const videoElement = event.currentTarget;
  videoElement.currentTime = 1.2;
};

  const StudentJoinButtonCondition = (singleSessionDetail?.isSessionStart && !sessionEnded && (singleSessionDetail?.participantscount > 0))

  const isServerUrlReady = !singleSessionDetail?.meetingType || (singleSessionDetail?.meetingType === "JITSI" && singleSessionDetail?.serverUrl);

  useEffect(()=>{
        
    const alreadyJoined = hasUserAlreadyJoined(singleSessionDetail?.participantIds || [], currentUserId);
        console.log(alreadyJoined, "alreadyJoined")
        if(alreadyJoined) {
        setAlreadyTwoUsersSameId(alreadyJoined)
        }
      else{
          setAlreadyTwoUsersSameId(false)
          setIsStudentButtonClicked(false)
      }
    },[singleSessionDetail?.participantIds])

    useEffect(()=>{
      if(sessionEnded) {
      setAlreadyTwoUsersSameId(false)
      }
    },[sessionEnded])

    useEffect(() => {
        const wayOfLeft = localStorage.getItem("wayOfLeft");
        const isManualLeft = localStorage.getItem("isManualLeft");
        if((meetService === CHIME) && !(wayOfLeft && wayOfLeft === 'invalid' && isManualLeft !== 'yes')) {
        localStorage.removeItem("isManualLeft");
        localStorage.removeItem("wayOfLeft");
        }
    }, []);

   return (
    <div className='SessionsListMainContainers'>
        {
          showCreateButton &&
         (
           getScreenDimensions()?.isMobileScreen ?
             <img src={ ScheduleMeeting } alt='createschedulebutton' className='mobilecreateButtonStyle' onClick={() => setShowCreateScheduling(true)}/>
             :
             <button className='createButtonStyle' onClick={() => setShowCreateScheduling(true)}>
               Create
             </button>)
        }
        <div className='sessionsListContainer'>
          <div 
            className='upcomingSessionMainContainer' 
            style={{
              height: singleSessionDetail ? '245px' : ''
            }}>
              {
                (singleSessionDetail?.sessionId) ?
                <>
                  <div className='singleSessionDetail'>
                    <div className='leftSideSessionDetail'>
                        <div className='sesstionTitle'>SESSION</div>
                        <div className='listOfSessionDetail'>
                          <div className='listsStyle'>
                              <div className='listStyle'>
                                  <div className='imgCtn'>
                                  <img src={calendarSymbol} alt='calendarIcon' className='sideIconStyle'/>
                                  </div>
                                  <div className='textStyle'>{daysleftValue}</div>
                              </div>
                              <div className='listStyle'>
                                  <div className='imgCtn'>
                                  <img src={clockSymbol} alt='clockIcon' className='sideIconStyle'/>
                                  </div>
                                  <div className='textStyle'>{startTime}</div>
                              </div>
                              <div className='listStyle'>
                                  <div className='imgCtn'>
                                  <img src={sandWatch} alt='sandIcon' className='sideIconStyle'/>
                                  </div>
                                  <div className='textStyle'>{duration}</div>
                              </div>
                          </div>
                          <div className='minsSeparationContainer'>
                              <div className='separationStyle'>{singleSessionDetail?.teachingPeriod ? formatPart(convertToMinutes(singleSessionDetail?.teachingPeriod)) : '0 min'}: Teaching</div>
                              <div className='separationStyleDiff'>{singleSessionDetail?.discussionPeriod ? formatPart(convertToMinutes(singleSessionDetail?.discussionPeriod)):'0 min'}: Interactions</div>
                          </div>
                        </div>
                    </div>
                    <div className='rightSideSessionDetail' style={(meetService === CHIME) ? {gap: '5px'} : undefined}>
                        <div className='lessonTopicContainer'>
                          <div className='heaaderStyle'>
                            <div className='headTextStyle'>LESSON TOPIC:</div>
                            <Tooltip
                              title={singleSessionDetail?.lessonTopic}
                              open={showTooltip}
                              placement="bottom"
                              disableInteractive
                            >
                              <div
                                ref={textRef}
                                className="ansHeadTextStyle"
                                onMouseEnter={handleMouseEnter}
                                onMouseLeave={handleMouseLeave}
                              >
                                {singleSessionDetail?.lessonTopic}
                              </div>
                            </Tooltip>
                          </div>
                          <Tooltip title={singleSessionDetail?.description} disableHoverListener={!isOverflow}>
                            <div
                              className='descriptionStyle'
                              ref={descriptionRef}
                              onMouseEnter={checkOverflow}
                              >
                              {singleSessionDetail?.description}
                            </div>
                          </Tooltip>
                        </div>
                     { role === STUDENT_ROLE ?
                       <div>
                       {isKatonMeet ? renderKatonMeetSessionButton() : <>
                       <button
                            className={`${(StudentJoinButtonCondition && !isStudentButtonClicked && !alreadyTwoUsersSameId && ((getIsJoinedLocalValue() === "left" || getIsJoinedLocalValue() === ''))) && ((meetService === JITSI) || (meetService === CHIME && !(isStartingMeeting))) ? 'sessionJoinButton' : 'notReadyStudentButtonStyle'}`} 
                            onClick={handleClickJoinButton}
                            disabled={meetService === CHIME ? isStartingMeeting : false}
                        >
                           {sessionEnded ? `Session Ended` : (singleSessionDetail?.isSessionStart && singleSessionDetail?.participantscount === 0) ? `Session completed` : singleSessionDetail?.isSessionStart ? `Join` : 'Not Ready'}
                       </button>
                       {!singleSessionDetail?.isSessionStart && !sessionEnded && singleSessionDetail?.isActive &&
                        <span className='sessionNotYetStarted'>
                          Host has not yet started the meeting
                        </span>
                       }
                      {alreadyTwoUsersSameId && (
                      <span className='alert-msg'>
                        {ALERT_MESSAGE_TWO_USERS}
                      </span>
                    )}
                      {(!(getIsJoinedLocalValue() === "left" || getIsJoinedLocalValue() === '')) && StudentJoinButtonCondition && !sessionEnded && !alreadyTwoUsersSameId && (
                            <span className='alreadyInMeeting'>
                                {ALERT_MESSAGE_ALREADY_IN_MEETING}
                            </span>
                      )}
                       </>}
                       </div>
                        :
                        <>
                      {!(singleSessionDetail?.isSessionStart) && (role === TEACHER_ROLE) && (meetService === CHIME) && (getIsJoinedLocalValue() === 'left' || getIsJoinedLocalValue() === '') && <div className='radioContainer'>
                          <FormLabel sx={{ color: "black", fontFamily: "var(--font-inter)", fontSize: "14px" }} component="legend">Chat :</FormLabel>
                            <RadioGroup
                              row
                              name="chat-options"
                              value={showChat}
                              onChange={() => setShowChat(!showChat)}
                            >
                              <FormControlLabel 
                                sx={{
                                  '& .MuiFormControlLabel-label': {
                                    color: 'black',
                                    fontFamily: 'var(--font-inter)',
                                    fontSize: '14px',
                                  },
                                }} 
                                value={true} 
                                control={
                                  <Radio sx={{
                                  transform: 'scale(0.8)', // scale down the radio circle
                                  padding: '4px',          // reduce padding if needed
                                  }} />
                                } 
                                label="Enable" 
                              />
                              <FormControlLabel 
                                sx={{
                                  '& .MuiFormControlLabel-label': {
                                    color: 'black',
                                    fontFamily: 'var(--font-inter)',
                                    fontSize: '14px',
                                  },
                                }} 
                                value={false} 
                                control={
                                  <Radio sx={{
                                    transform: 'scale(0.8)', // scale down the radio circle
                                    padding: '4px',          // reduce padding if needed
                                  }} />
                                } 
                                label="Disable" 
                              />
                              </RadioGroup>
                        </div>}
                        <div>
                        {isKatonMeet ? renderKatonMeetSessionButton() : <>
                        <button
                         className={`${(singleSessionDetail?.isActive && !sessionEnded && !isTeacherButtonClicked && isServerUrlReady && !alreadyTwoUsersSameId && ((getIsJoinedLocalValue() === "left" || getIsJoinedLocalValue() === ''))) ? 'sessionStartButton' : 'notReadyButtonStyle'} ${(singleSessionDetail?.isSessionStart && isServerUrlReady) ? 'sessionStartButton' : ''}`} 
                         onClick={
                          meetService === JITSI ?
                          (singleSessionDetail?.isSessionStart ? handleClickJoinButton : handleClickStartButton)
                          : ((singleSessionDetail?.isSessionStart && singleSessionDetail?.participantscount === 0) ? handleClickStartButton : (singleSessionDetail?.isSessionStart && singleSessionDetail?.participantscount > 0) ? handleClickJoinButton : handleClickStartButton)
                         }
                         disabled={meetService === CHIME ? isStartingMeeting : false}
                        > 
                         {(isStartingMeeting && (meetService === CHIME)) ? (
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <CircularProgress size={15} color="inherit" />
                            </div>
                          )
                            :                                        
                           sessionEnded ? `Session Ended` : (singleSessionDetail?.isActive && !singleSessionDetail?.isSessionStart && isServerUrlReady) ? `Start` :(singleSessionDetail?.isSessionStart && isServerUrlReady)? 'Join' : 'Not Ready'
                         }
                       </button>
                       {alreadyTwoUsersSameId && (
                        <span className='alert-msg'>
                          {ALERT_MESSAGE_TWO_USERS}
                        </span>
                      )}
                       {(!(getIsJoinedLocalValue() === "left" || getIsJoinedLocalValue() === '')) && singleSessionDetail?.isActive && !sessionEnded && isServerUrlReady && !alreadyTwoUsersSameId && (
                            <span className='alreadyInMeeting'>
                                {ALERT_MESSAGE_ALREADY_IN_MEETING}
                            </span>
                        )}
                       </>}
                       </div>
                       </>
                     }
                    </div>
                  </div>
                </> :
                upcomingSessionList?.length > 0 ?
                <>
                    <div className='upComingSessionTitle'>Scheduled Sessions</div>
                    <div className='upcomingSessionListContainer'>
                        <div className='cardContainer'>
                          {
                            upcomingSessionList?.map((cardItem: LiveSessionListType,index: number) => {
                              const {dayMessage,formattedDate,dayOfWeek} = getFormattedDateInfo(cardItem?.startDate);
                              return (
                                <div className={(cardItem?.isactive && (role === TEACHER_ROLE)) ? "activeSessionForTeacher" : 'upcomingSessionCard'} onClick={() => onClickSingleSession(cardItem)} key={`${index}-${cardItem?.sessionId}`}>
                                      <div className='titleContainer'>
                                        <div className={cardItem?.isactive ? 'activeDotContainer': 'forTeacherStyle'} style={{backgroundColor: ((cardItem?.isactive) && (role === STUDENT_ROLE)) ? 'var(--color-steelblue)' : '', marginLeft: ((cardItem?.isactive) && (role === STUDENT_ROLE)) ? '25px' : '17px'}}>
                                          {cardItem?.isactive ? <span className='activeDot'></span> : ''}
                                          <div className={(cardItem?.isactive && (role === TEACHER_ROLE)) ? 'activeTitleStyle' : 'titleStyle'} style={{color: (cardItem?.isactive ? 'white' : 'black')}}>{dayMessage}</div>
                                        </div>
                                        {
                                          role !== STUDENT_ROLE && !cardItem?.isSessionStart
                                          ? 
                                          <div className='moreIconContainer' onClick={(e) => onClickMoreIcon(e,cardItem)}>
                                            <img src={cardItem?.isactive ? WhiteMoreIcon : MoreIcon} alt='more' className='moreIconStyle'/>
                                          </div>
                                          : 
                                          <></>
                                        }
                                          
                                      </div>
                                      <div className='dayContainer'>
                                          <div className={(cardItem?.isactive && (role === TEACHER_ROLE)) ? 'activeDayStyle': 'dayStyle'}>{dayOfWeek}</div>
                                          <div className={(cardItem?.isactive && (role === TEACHER_ROLE)) ? 'activeMonthDateStyle' : 'monthDateStyle'}>{formattedDate}</div>
                                      </div>
                                </div>
                                )
                            }
                          )
                          }
                        </div>
                        <Menu
                                id="action-menu"
                                MenuListProps={{
                                    "aria-labelledby": "long-button",
                                    disablePadding: true,
                                }}
                                anchorEl={anchorEl}
                                open={openMenu}
                                onClose={handleCloseMenu}
                                anchorOrigin={{
                                    vertical: 'center',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                sx={{
                                    '& .MuiPaper-root': {
                                        borderRadius: '5px',
                                        boxShadow: '-10px 10px 15px 0.2px rgba(0, 0, 0, 0.05)',
                                    },
                                }}
                                classes={{
                                  paper: 'menuPaperStyle'
                                }}
                          >
                            <div className='menuitemContainer'>
                                <MenuItem className='menuItemStyle' onClick={onClickEditOption} disabled={!isMenuSessionLoaded}>
                                    <img src={ResetCode} alt='resetCodeIcon'/>
                                    <p className='labelStyle'>Edit</p>
                                </MenuItem>
                                <MenuItem className='menuItemStyle' onClick = {onClickDeleteScheduleOption} disabled={!isMenuSessionLoaded}>
                                    <img src={DeleteClass} alt='deleteClassIcon'/>
                                    <p className='labelStyle'>Delete Schedule</p>
                                </MenuItem>
                            </div>
                          </Menu>
                    </div>
                </> 
                :
                <>
                    <div className='noMeetings'>
                        <img alt='gif' src={LiveSessionGif} className='scheduleMeetGifStyle'/>
                        <div className='noMeetingsText'>{`No Meeting Available`}</div>
                        {isMobileScreen && role === TEACHER_ROLE && (
                          <button className='createButtonStyle' onClick={() => setShowCreateScheduling(true)}>
                            Create
                          </button>
                        )}
                    </div>
                </>
                
              }
          </div>
          <div className='savedSessionsMainContainer' style={{height: (singleSessionDetail?.sessionId) ? 'calc(100% - 258px)' : 'calc(100% - 192px)'}}>
              <div className='savedSessionTitle'>Saved Sessions</div>
              <div className='savedSessionListContainer' style={{display: !(savedSessionsList && savedSessionsList?.totalCount > 0) ? 'flex' : ''}}>
                    {
                      savedSessionsList && savedSessionsList?.totalCount > 0 ?

                        ((savedSessionsList) && savedSessionsList?.nodes?.map((videoItem: SavedSessionType,index: number) => (
                          <div className='videoContainer' onClick={() => handleClickVideo(videoItem)}>
                              <video src={videoItem?.savedSessionUrl ? `${buildRecordingUrl(videoItem?.savedSessionUrl, videoItem?.isKatonMeet)}${isSafariBrowser?'#t=0.001':''}` : ''} muted loop className='videoTagStyle' onCanPlay={(event) => handleLoadedMetadata(event)}/>
                              <div className='descriptionContainer'>
                                  <div className='savedDateStyle'>{formatSavedDate(videoItem?.createdAt)}</div>
                                  <Tooltip title={videoItem?.topic} disableHoverListener={!isDescOverflow[index]}>
                                      <div className='descriptionStyle' onMouseEnter={() => checkOverflowVideoDescription(index)} onMouseMove={() => checkOverflowVideoDescription(index)} ref={(el) => (videoDescriptionRef.current[index] = el)}>
                                        {videoItem?.topic}
                                      </div>
                                  </Tooltip>
                              </div>
                              <img src={videoPlayIcon} className='playIconStyle' alt='videoPlayIcon'/>
                          </div>
                        ))
                      )
                      :
                      <div className='noDataFoundStyle'>
                        {`No data found`}
                      </div>
                    }
              </div>
          </div>
        </div>
        <ConfirmationPopup
          open={openConfirmationPopup}
          message={`Are you sure you want to Delete this session?`}
          gifData={DeleteGif}
          yesButtonFunctionality={onYesButtonClick}
          noButtonFunctionality={onNoButtonClick}
          messageWidth={'195px'}
        />
        <WarningPopup
          message={ warningMessage }
          openWarningPopup={ openWarningPopup }
          closeWarnPopup={ closeWarnPopup }
        />
    </div>
  )
}

export default SessionsList;
